/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editTransformer.vue?vue&type=template&id=4f3e4ed3&scoped=true"
import script from "./editTransformer.vue?vue&type=script&lang=js"
export * from "./editTransformer.vue?vue&type=script&lang=js"
import style0 from "./editTransformer.vue?vue&type=style&index=0&id=4f3e4ed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e4ed3",
  null
  
)

export default component.exports